import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import withEndpointAuthorization from '../../authorization/withEndPointAuthorization';
import EditParcelAccountingDataModalForm from './EditParcelAccountingDataModalForm';
import Modal from '../../../common/modal/Modal';
import { PUT } from '../../../../config/permissions';
import { putAcountingData } from '../../../../actions/cargo';
import { generateParcelAccountingDataEndpoint } from '../../../../config/endpoints';

const EditParcelAccountingDataButton = ({
  parcel,
  dispatchPutAcountingData,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [body, setBody] = useState(null);

  const onSubmit = (formValues) => {
    const newFormValues = { ...formValues };

    const business = parcel.business || null;

    if (business) {
      newFormValues.businessId = business.id;
      newFormValues.isBusiness = true;
    } else {
      newFormValues.isBusiness = false;
    }

    dispatchPutAcountingData(parcel.id, newFormValues);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const generateInitialValues = () => {
    const initialValues = {};
    const { customer, business } = parcel;

    // ✅ Compatible con tu JSON
    if (business) {
      initialValues.newBusinessName = business.name;
      initialValues.newBusinessTaxId = business.businessTaxId;
    } else if (customer) {
      initialValues.idDocumentNumber = customer.idDocumentNumber;
    }

    return initialValues;
  };

  const handleShowModal = () => {
    const initialValues = generateInitialValues();

    const content = (
      <EditParcelAccountingDataModalForm
        onCancel={handleCloseModal}
        onSubmit={onSubmit}
        initialValues={initialValues}
      />
    );

    setBody(content);
    setShowModal(true);
  };

  return (
    <>
      <Button color="light" className="border" onClick={handleShowModal}>
        <i className="fa fa-pencil-square-o" /> Editar Datos Contables
      </Button>

      <Modal
        body={body}
        title="Editar Datos Contables"
        show={showModal}
        onClickCancel={handleCloseModal}
        onClickClose={handleCloseModal}
      />
    </>
  );
};

EditParcelAccountingDataButton.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  parcel: PropTypes.object.isRequired,
  dispatchPutAcountingData: PropTypes.func.isRequired,
};

export const mapDispatchToProps = {
  dispatchPutAcountingData: putAcountingData,
};

const connectedComponent = connect(
  null,
  mapDispatchToProps,
)(EditParcelAccountingDataButton);

export default withEndpointAuthorization({
  url: generateParcelAccountingDataEndpoint(0),
  permissionType: PUT,
})(connectedComponent);
